import { render, staticRenderFns } from "./LastOrderTime.vue?vue&type=template&id=23bc4624"
import script from "./LastOrderTime.vue?vue&type=script&lang=ts"
export * from "./LastOrderTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports